export type OpeningWrappingMode =
  | typeof NO_WRAPPING
  | typeof WRAP_EXTERIOR_CORE_FACE
  | typeof WRAP_CENTER_OF_CORE
  | typeof WRAP_INTERIOR_CORE_FACE;

export const NO_WRAPPING = "NONE";
export const WRAP_EXTERIOR_CORE_FACE = "EXTERIOR_CORE_FACE";
export const WRAP_CENTER_OF_CORE = "CENTER_OF_CORE";
export const WRAP_INTERIOR_CORE_FACE = "INTERIOR_CORE_FACE";

export enum OpeningWrappingModeEnum {
  NONE = "NONE",
  EXTERIOR_CORE_FACE = "EXTERIOR_CORE_FACE",
  CENTER_OF_CORE = "CENTER_OF_CORE",
  INTERIOR_CORE_FACE = "INTERIOR_CORE_FACE",
}
